<template>
  <div class="btn-group" v-if="can('write_customer_tokens')">
    <button class="btn btn-primary" @click="impersonate_as_support">{{ 'impersonate' | t }}</button>
    <button
      class="btn btn-primary dropdown-toggle dropdown-toggle-split"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      @click="load_users"
    >
      <span class="sr-only"></span>
    </button>
    <div class="dropdown-menu">
      <a class="dropdown-item" @click="impersonate_user(user)" v-for="user in users"
        >{{ user.first_name }} {{ user.email }}</a
      >
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
import clientApi from '@/store/clientapi';
import config from '@/config';

export default {
  /***  Setup  ***/
  props: {
    tenant: String
  },

  data() {
    return {
      users: [],
      loaded_users: false,
      client_token: null
    };
  },

  /***  Methods  ***/
  methods: {
    /***  Actions  ***/
    async set_client_token() {
      if (!this.client_token) {
        let { data } = await Api.create('customer_tokens', {
          tenant: this.tenant
        });
        this.client_token = data;
      }
    },
    async load_users() {
      if (this.loaded_users) {
        return;
      }
      await this.set_client_token();
      this.$store.commit('setCurrentTenant', {
        tenantName: this.tenant,
        token: this.client_token.token,
        refreshToken: this.client_token.refresh_token,
        expiresAt: this.client_token.expires_at
      });
      let { data } = await clientApi.findAll('users', {
        include: 'user_group'
      });
      this.users = data;
      this.loaded_users = true;
    },
    async impersonate_as_support() {
      await this.set_client_token();
      this.impersonate(this.client_token);
    },
    async impersonate_user(user) {
      let { data } = await Api.create('customer_tokens', {
        tenant: this.tenant,
        user_id: user.id
      });
      this.impersonate(data);
    },
    impersonate(token) {
      window.open(
        config.frontend.protocol +
          this.tenant +
          config.frontend.domain +
          '/impersonate?access_token=' +
          token.token +
          '&refresh_token=' +
          token.refreshToken,
        '_blank'
      );
    }
  }
};
</script>
